<template>
    <div class="swiper-awe">
            <swiper :options="swiperOption" ref="mySwiper">
                  <slot></slot>
            </swiper>
            <div :class="'swiper-pagination swiper-pagination-'+prevName" slot="pagination" v-if="pagination"></div>
            <div :class="'swiper-button-prev swiper-button-prev-'+prevName" slot="button-prev" v-if="turnPages"></div>
            <div :class="'swiper-button-next swiper-button-next-'+nextName" slot="button-next"  v-if="turnPages"></div>
    </div>
</template>
<script>
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '../swiper3.1.3.css'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    pagination: {
      default: false,
      type: Boolean
    },
    turnPages: {
      default: false,
      type: Boolean
    },
    swiperData: {
      default: () => { return {} },
      type: Object
    },
    name: {
      default: '',
      type: String,
      required: false
    },
    prevName: {
      default: '',
      type: String
    },
    nextName: {
      default: '',
      type: String
    }
  },
  name: 'awesomeSwiper',
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 1,
        preventLinksPropagation: false,
        pagination: {
          el: '.swiper-pagination-' + this.prevName,
          clickable: true
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next-' + this.nextName,
          prevEl: '.swiper-button-prev-' + this.prevName
        },
        threshold: 20,
        on: {
          click: (e) => {
            localStorage.setItem('from',"home")
            //add by cpgu 2022/07/22 添加以下if判断逻辑，解决首页banner轮播时，点击"sign up to shop"按钮时无法触发登陆框问题
            if (this.name == 'home-banner') {
              if (e.target.getAttribute("class").includes("banner-button")) {
                this.showLogin()
              }
              //end by cpgu
            } else {
              let url = e.target.getAttribute('openurl')
              if(url){
                this.$router.push({
                  path: url
                })
              }

            }


          }
        }
      }
    }
  },
  created() {
    this.swiperOption = {
      ...this.swiperOption, ...this.swiperData
    }
  },
  methods:{
    showLogin(){
      this.$emit("showLoginHandle");
    },
  },
  computed: {

  },
  mounted() {

  }

}
</script>

<style lang="less" scoped>
.swiper-awe{
  position: relative;
}
/deep/.swiper-button-prev{
  width: 10px;
  left: -35px;
  background-image:url('../../../assets//img/home/left.png');
  background-size:10px 20px ;
}
/deep/.swiper-button-next{
  width: 10px;
  right: -35px;
  background-image:url('../../../assets//img/home/right.png');
  background-size:10px 20px ;
}
/deep/.swiper-pagination-bullet{
  width: 8px;
  height: 8px;
  background: rgba(143,143,143,0.3900);
  border-radius: 50%;
  opacity: 1;
}
/deep/.swiper-pagination-bullet-active{
background: rgba(38,43,47,0.3900);
}
/deep/ .swiper-pagination{
  left: 0;
  right: 0;
}
/deep/.swiper-pagination-bullet{
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/awesomeSwiper.vue